import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=081e0610&scoped=true&"
import script from "./AdminUsers.vue?vue&type=script&lang=js&"
export * from "./AdminUsers.vue?vue&type=script&lang=js&"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=081e0610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e0610",
  null
  
)

export default component.exports